const containerWidth = {
  backgroundColor: "white",
  width: "100%",
  maxWidth: "40rem"
}

const uploadButton = {
  border: "2px dashed #CECECE",
  backgroundColor: "#F2F2F2",
  ":hover": {
    backgroundColor: "#EAEAEA",
    borderColor: "#C7C7C7",
    boxShadow: "none"
  },
  color: "black"
}

export default {
  containerWidth,
  uploadButton
}
